import React, { Fragment, useState, useEffect } from "react";
import { Card, Modal, Button, Form, Spinner } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import useRequests from "../../../utils/useRequests";
import DataTable from "react-data-table-component";


const UserList = () => {
  const location = useLocation();
  const { getRequest, deleteRequest, putRequest } = useRequests();
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(""); // "enable", "disable", "delete"
  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

 

  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [loading, setLoading] = useState(true);

  const fetchUsers = async () => {
    const response = await getRequest("user-list"); // Replace "users" with the appropriate API endpoint
    if (response && response.code === 200) {
      setUsers(response.data);
    } else {
      console.error("Failed to fetch users:", response.message);
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: 'Failed to fetch users',
      }));
    }
    resetAlertData();
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers();
    if (location.state && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
      setLoading(false);
    }
  }, []);

  // Filter users based on the search query
  const filteredUsers = users.filter((user) => {
    const email = `${user.email? user.emai: "N/A"}`.toLowerCase();
    const phone = `${user.phone}`;
    const aadhar = user.aadhar ? user.aadhar : "-";
    const status = `${user.status}`.toLowerCase();
    const fullName = `${user.first_name? user.first_name +" "+user.last_name : "N/A"}`.toLowerCase();
    // const query = {fullName, email};
    // return query.includes(searchQuery.toLowerCase());
    const searchLower = searchQuery.toLowerCase();
  
    return  fullName.includes(searchLower) || email.includes(searchLower) || phone.includes(searchLower) || status.includes(searchQuery) || aadhar.includes(searchQuery);
  });

  const handleOpenModal = (user, type) => {
    setSelectedUser(user);
    setModalType(type);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalType("");
    setSelectedUser(null);
  };

  const [isProcessing, setIsProcessing] = useState(false);
  const handleConfirmAction = async () => {
    if (selectedUser) {
      setIsProcessing(true);
      if (modalType === "delete") {
        const response = await deleteRequest(`user-delete/${selectedUser.u_id}`);
        if (response && response.code === 200) {
          const updatedUsers = users.filter((user) => user.u_id !== selectedUser.u_id);
          setUsers(updatedUsers);
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: 'User deleted successfully!',
          }));
          resetAlertData();
        } else {
          console.error("Failed to delete user:", response?.message);
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: 'Failed to delete user',
          }));
          resetAlertData();
        }
      } else if (modalType === "enable" || modalType === "disable") {
        const newStatus = modalType === "enable" ? "Enable" : "Disable";
        try {
          const jsonpar = JSON.stringify({status: newStatus});
          const response = await putRequest(`user-status/${selectedUser.u_id}`, jsonpar);
          if (response && response.code === 200) {
            const updatedUsers = users.map((user) =>
              user.u_id === selectedUser.u_id ? { ...user, status: newStatus } : user
            );
            setUsers(updatedUsers);
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: `User ${newStatus}d successfully`,
            }));
            resetAlertData();
          } else {
            console.error("Failed to update status:", response?.message);
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: `Failed to ${newStatus} user.`,
            }));
            resetAlertData();
          }
        } catch (error) {
          console.error("Error updating status:", error);
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: 'Error updating status',
          }));
          resetAlertData();
        }
      }
      setIsProcessing(false);
      handleCloseModal();
    }
  };

  const columns = [
    {
      name: "Full Name",
      selector: (row) => `${row.first_name? row.first_name +" "+row.last_name : "N/A"}`,
      sortable: true,
    },
    {
      name: "Email ID",
      selector:(row) => `${row.email? row.email: "N/A"}`,
      sortable: true,
    },
    {
      name: "Mobile Number",
      selector: (row) => row.phone,
      sortable: true,
    },
    {
      name: "Aadhar Card",
      selector: (row) =>  row.aadhar ? row.aadhar : "-",
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => 
         row.o_id != row.org_id ? (
        <span>-</span>
      ) :(
        <button
          onClick={() =>
            handleOpenModal(row, row.status === "Enable" ? "disable" : "enable")
          }
          className={`btn ${
            row.status === "Enable" ? "btn-success" : "btn-danger"
          } btn-xxs`}
        >
          {row.status === "Enable" ? "Enable" : "Disable"}
        </button>
      ),
      center: true,
      width: "150px",
    },
    {
      name: "Actions",
      cell: (row) => 
        row.o_id != row.org_id ? (
        <span>-</span>
      ) :(
        <div className="text-center">
          <Link className="btn btn-primary btn-xxs me-2" to={`/user-edit/${row.u_id}`} title="Edit User">
            <i className="fa-regular fa-pen-to-square"></i>
          </Link>
          <button className="btn btn-danger btn-xxs me-2" onClick={() => handleOpenModal(row, "delete")}  title="Delete User">
            <i className="fa-solid fa-trash"></i>
          </button>
        </div>
      ),
      center: true,
      width: "220px",
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headCells: {
      style: {
        color: "#341439",
        fontSize: "17px",
        fontWeight: "600",
        paddingLeft: "8px", // Adjust padding
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        fontSize: "16px",
        padding: "12px 9px",
        color: "#7E7E7E",
      },
    },
    pagination: {
      style: {
        fontSize: "16px",
      },
    },
  };

  // if (loading) return <p>Fetching data...</p>;

  return (
    <Fragment>
      {AlertData.message !== "" ? (
          <Snackbars variant={AlertData.variant} message={AlertData.message} />
        ) : (
          ""
        )}
      <div className='d-sm-flex d-block justify-content-between align-items-center mb-4'>
        <h2 className='text-black font-w600 mb-0'>User Management</h2>

        {/* Wrap both buttons in a right-aligned flex box */}
        <div className='d-flex gap-2'>
          <Link
            to='/user-add'
            type='button'
            className='btn btn-rounded btn-primary'
          >
            Add New User
          </Link>
          <Link
            to='/user-add-existing'
            type='button'
            className='btn btn-rounded btn-primary'
          >
            Add Existing User
          </Link>
        </div>
      </div>


      {/* Search input */}
      <div className='mb-4 d-sm-flex d-block justify-content-end'>
      <div style={{ position: "relative", width: "18rem" }}>
  <Form.Control
    type="text"
    placeholder="Search..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    style={{
      width: "100%",
      fontSize: "18px",
      fontWeight: 500,
      paddingRight: "2rem",
      borderRadius:'0.625rem',
      height:'3.2rem' // Add padding to ensure the icon doesn't overlap text
    }}
  />
  <i
    className="fa fa-search"
    style={{
      position: "absolute",
      right: "10px", // Distance from the right edge of the input
      top: "50%",
      transform: "translateY(-50%)", // Center vertically
      color: "#6c757d", // Optional: color for the icon
      pointerEvents: "none", // Makes sure clicks pass through to the input
    }}
  ></i>
</div>
      </div>

      <Card>
        <Card.Body>
          {loading ? (
                <div className='text-center'>
                  <Spinner animation='border' />
                  <p>Loading settings...</p>
                </div>) : 
          (<DataTable
            columns={columns}
            data={filteredUsers} // Use filtered data
            customStyles={customStyles}
            pagination
            highlightOnHover
            responsive
          />)}
        </Card.Body>
      </Card>

      {/* Enable/Disable/Delete Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "enable" && "Enable User"}
            {modalType === "disable" && "Disable User"}
            {modalType === "delete" && "Delete User"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalType === "delete" ? (
            <>
              Are you sure you want to delete the user{" "}
              <strong>
                {selectedUser?.first_name? selectedUser?.first_name +" "+ selectedUser?.last_name : selectedUser?.phone}
              </strong>
              ? This action cannot be undone.
            </>
          ) : (
            `Are you sure you want to ${modalType} the user ${selectedUser?.first_name? selectedUser?.first_name +" "+ selectedUser?.last_name : selectedUser?.phone}?`
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='light' onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            className={`btn btn-${
              modalType === "enable"
                ? "success"
                : modalType === "disable"
                ? "danger"
                : "danger"
            }`}
            onClick={handleConfirmAction}
            disabled={isProcessing}
          >
            {modalType === "enable" && "Enable"}
            {modalType === "disable" && "Disable"}
            {modalType === "delete" && "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default UserList;
